/**
 * 注册路由
 * 2017-12-6
 */
"use strict";
angular.module("authenticationRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("register.authentication",{
        url:"/authentication?userType",
        views:{
            "main@register": {
                templateUrl: "./login/register/authentication/authentication_tpl.html",
                controller: "authenticationCtrl"
            }
        }
    });
}]);